/**
 * pi-advanced-ugc.js — Standalone script for `sections/pi-advanced-ugc-slider.liquid` only.
 * Custom elements: <pi-advanced-ugc-slider>, <pi-advanced-ugc-modal>. Not related to `pi-ugc-slider.js`.
 * Depends on Swiper 11 (theme.liquid). Destroys Swiper on disconnect.
 */
(function () {
  'use strict';

  /** @param {string} [selector] Full CSS selector (e.g. script[data-pi-adv-ugc-config]), not a bare attribute name */
  function parseJson(el, selector) {
    var node = selector ? el.querySelector(selector) : el;
    if (!node || !node.textContent) return null;
    try {
      return JSON.parse(node.textContent.trim());
    } catch (e) {
      return null;
    }
  }

  function formatMoney(cents, moneyFormat) {
    if (cents == null || isNaN(cents)) return '';
    var fmt = moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/i, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/i, String(Math.round(cents / 100)));
  }

  function findVariantForOptions(product, selected) {
    if (!product || !product.variants) return null;
    var vs = product.variants;
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i];
      var ok = true;
      for (var o = 0; o < selected.length; o++) {
        var key = 'option' + (o + 1);
        if (v[key] !== selected[o]) {
          ok = false;
          break;
        }
      }
      if (ok) return v;
    }
    return vs[0] || null;
  }

  /** @param {HTMLElement} root */
  function initGallerySwiper(root) {
    if (typeof window.Swiper === 'undefined') return null;
    var el = root.querySelector('.pi-advanced-ugc-modal__gallery.swiper');
    if (!el) return null;
    var bar = root.querySelector('[data-pi-gallery-progress]');
    return new window.Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      on: {
        slideChange: function (sw) {
          if (!bar || !sw.slides.length) return;
          var p = ((sw.activeIndex + 1) / sw.slides.length) * 100;
          bar.style.width = p + '%';
        },
        init: function (sw) {
          if (!bar || !sw.slides.length) return;
          bar.style.width = (100 / sw.slides.length) + '%';
        }
      }
    });
  }

  class PiUgcModal extends HTMLElement {
    connectedCallback() {
      if (this._piBound) return;
      this._piBound = true;
      this._main = this.querySelector('dialog[data-pi-main-dialog]');
      this._sheet = this.querySelector('dialog[data-pi-sheet]');
      this._video = this.querySelector('[data-pi-modal-video]');
      this._muteBtn = this.querySelector('[data-pi-mute]');
      this._closeBtns = this.querySelectorAll('[data-pi-close-main]');
      this._desktopCol = this.querySelector('[data-pi-desktop-product]');
      this._mobileStrip = this.querySelector('[data-pi-mobile-strip]');
      this._sheetScroll = this.querySelector('[data-pi-sheet-scroll]');
      this._sheetFooter = this.querySelector('[data-pi-sheet-footer]');
      this._config = parseJson(this, 'script[data-pi-modal-config]') || {};
      this._products = parseJson(this, 'script[data-pi-products]') || [];
      this._bp = parseInt(this._config.breakpoint, 10) || 990;
      this._gallerySwiper = null;
      this._currentIndex = -1;
      this._selectedOptions = [];
      this._moneyFormat = this._config.moneyFormat || '${{amount}}';

      var self = this;
      this._mq = window.matchMedia('(min-width: ' + this._bp + 'px)');
      function syncLayout() {
        self.classList.toggle('pi-advanced-ugc-modal--layout-desktop', self._mq.matches);
      }
      syncLayout();
      if (this._mq.addEventListener) this._mq.addEventListener('change', syncLayout);
      else this._mq.addListener(syncLayout);

      this._closeBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          self.closeMain();
        });
      });
      if (this._main) {
        this._main.addEventListener('click', function (e) {
          if (e.target === self._main) self.closeMain();
        });
      }
      if (this._muteBtn && this._video) {
        this._muteBtn.addEventListener('click', function () {
          self._video.muted = !self._video.muted;
          self._muteBtn.setAttribute('aria-pressed', self._video.muted ? 'true' : 'false');
          self._muteBtn.dataset.muted = self._video.muted ? '1' : '0';
        });
      }
      if (this._mobileStrip) {
        this._mobileStrip.addEventListener('click', function () {
          if (!self._mq.matches) self.openSheet();
        });
      }
      var sheetClose = this.querySelectorAll('[data-pi-close-sheet]');
      sheetClose.forEach(function (b) {
        b.addEventListener('click', function () {
          self.closeSheet();
        });
      });
      if (this._sheet) {
        this._sheet.addEventListener('click', function (e) {
          if (e.target === self._sheet) self.closeSheet();
        });
      }
    }

    openMain(index) {
      var p = this._products[index];
      if (!p || !this._main) return;
      this._currentIndex = index;
      this._selectedOptions = (p.options || []).map(function (opt, i) {
        return p.selected_options && p.selected_options[i] != null ? p.selected_options[i] : opt.values[0];
      });
      if (this._video) {
        this._video.pause();
        this._video.removeAttribute('src');
        var src = p.video_src;
        if (src) {
          this._video.src = src;
          this._video.muted = true;
          this._video.playsInline = true;
          this._video.play().catch(function () {});
        }
      }
      if (this._muteBtn) {
        this._muteBtn.dataset.muted = '1';
        this._muteBtn.setAttribute('aria-pressed', 'true');
      }
      this._renderProductColumn(p);
      this._renderMobileStrip(p);
      this._renderSheet(p);
      this._main.showModal();
      this._main.classList.add('pi-advanced-ugc-modal--open');
    }

    closeMain() {
      if (this._video) {
        this._video.pause();
        this._video.removeAttribute('src');
      }
      if (this._main && this._main.open) this._main.close();
      if (this._main) this._main.classList.remove('pi-advanced-ugc-modal--open');
      this.closeSheet();
      if (this._gallerySwiper) {
        try {
          this._gallerySwiper.destroy(true, true);
        } catch (e) {}
        this._gallerySwiper = null;
      }
    }

    openSheet() {
      if (this._sheet && !this._mq.matches) {
        this._sheet.showModal();
        this._sheet.classList.add('pi-advanced-ugc-modal__sheet--open');
      }
    }

    closeSheet() {
      if (this._sheet && this._sheet.open) this._sheet.close();
      if (this._sheet) this._sheet.classList.remove('pi-advanced-ugc-modal__sheet--open');
    }

    _renderProductColumn(p) {
      if (!this._desktopCol) return;
      var v = findVariantForOptions(p, this._selectedOptions);
      var price = v && v.price != null ? formatMoney(v.price, this._moneyFormat) : p.price_formatted || '';
      var html = '';
      if (p.media && p.media.length) {
        html += '<div class="pi-advanced-ugc-modal__gallery swiper"><div class="swiper-wrapper">';
        for (var i = 0; i < p.media.length; i++) {
          html +=
            '<div class="swiper-slide"><img class="pi-advanced-ugc-modal__gallery-img" src="' +
            escapeAttr(p.media[i].src) +
            '" alt="" loading="lazy" width="400" height="400"/></div>';
        }
        html += '</div></div>';
        html += '<div class="pi-advanced-ugc-modal__gallery-progress"><div class="pi-advanced-ugc-modal__gallery-progress-bar" data-pi-gallery-progress style="width:' + (p.media.length ? 100 / p.media.length : 100) + '%"></div></div>';
      }
      html += '<h2 class="pi-advanced-ugc-modal__product-title">' + escapeHtml(p.title) + '</h2>';
      html += '<p class="pi-advanced-ugc-modal__product-price">' + escapeHtml(price) + '</p>';
      html += this._variantHtml(p);
      html += '<div class="pi-advanced-ugc-modal__actions">';
      html +=
        '<a class="pi-advanced-ugc-modal__btn-secondary" href="' +
        escapeAttr(p.url) +
        '">' +
        (this._config.moreInfoLabel || 'More info') +
        '</a>';
      html +=
        '<button type="button" class="pi-advanced-ugc-modal__btn-primary" data-pi-add-cart>' +
        (this._config.addToCartLabel || 'Add to cart') +
        '</button>';
      html += '</div>';
      html += '<div class="pi-advanced-ugc-modal__accordion"><button type="button" class="pi-advanced-ugc-modal__accordion-toggle" data-pi-acc>' + (this._config.descriptionLabel || 'Description') + '<span>▼</span></button><div class="pi-advanced-ugc-modal__accordion-body">' + (p.description || '') + '</div></div>';
      this._desktopCol.innerHTML = html;
      this._wireProductUi(p, this._desktopCol);
      var self = this;
      requestAnimationFrame(function () {
        if (self._gallerySwiper) {
          try {
            self._gallerySwiper.destroy(true, true);
          } catch (e) {}
          self._gallerySwiper = null;
        }
        self._gallerySwiper = initGallerySwiper(self);
      });
    }

    _renderMobileStrip(p) {
      if (!this._mobileStrip) return;
      var v = findVariantForOptions(p, this._selectedOptions);
      var price = v && v.price != null ? formatMoney(v.price, this._moneyFormat) : p.price_formatted || '';
      var img = p.featured_image || (p.media && p.media[0] && p.media[0].src) || '';
      this._mobileStrip.innerHTML =
        '<img class="pi-advanced-ugc-modal__mobile-product-thumb" src="' +
        escapeAttr(img) +
        '" alt=""/><div class="pi-advanced-ugc-modal__mobile-product-text"><p class="pi-advanced-ugc-modal__mobile-product-title">' +
        escapeHtml(p.title) +
        '</p><p class="pi-advanced-ugc-modal__mobile-product-price">' +
        escapeHtml(price) +
        '</p></div><button type="button" class="pi-advanced-ugc-modal__mobile-product-cta">' +
        (this._config.shopNowLabel || 'Shop now') +
        ' ›</button>';
    }

    _renderSheet(p) {
      if (!this._sheetScroll || !this._sheetFooter) return;
      var v = findVariantForOptions(p, this._selectedOptions);
      var price = v && v.price != null ? formatMoney(v.price, this._moneyFormat) : p.price_formatted || '';
      var gallery = '';
      if (p.media && p.media.length) {
        gallery += '<div class="pi-advanced-ugc-modal__gallery swiper pi-advanced-ugc-modal__sheet-gallery"><div class="swiper-wrapper">';
        for (var i = 0; i < p.media.length; i++) {
          gallery +=
            '<div class="swiper-slide"><img class="pi-advanced-ugc-modal__gallery-img" src="' +
            escapeAttr(p.media[i].src) +
            '" alt="" loading="lazy"/></div>';
        }
        gallery += '</div></div>';
        gallery +=
          '<div class="pi-advanced-ugc-modal__gallery-progress"><div class="pi-advanced-ugc-modal__gallery-progress-bar" data-pi-sheet-gallery-progress style="width:' +
          (100 / p.media.length) +
          '%"></div></div>';
      }
      this._sheetScroll.innerHTML =
        gallery +
        '<h2 class="pi-advanced-ugc-modal__product-title">' +
        escapeHtml(p.title) +
        '</h2><p class="pi-advanced-ugc-modal__product-price">' +
        escapeHtml(price) +
        '</p>' +
        this._variantHtml(p) +
        '<div class="pi-advanced-ugc-modal__accordion is-open"><button type="button" class="pi-advanced-ugc-modal__accordion-toggle" data-pi-acc-sheet>' +
        (this._config.descriptionLabel || 'Description') +
        '<span>▼</span></button><div class="pi-advanced-ugc-modal__accordion-body">' +
        (p.description || '') +
        '</div></div>';
      this._sheetFooter.innerHTML =
        '<a class="pi-advanced-ugc-modal__btn-secondary" href="' +
        escapeAttr(p.url) +
        '">' +
        (this._config.moreInfoLabel || 'More info') +
        '</a><button type="button" class="pi-advanced-ugc-modal__btn-primary" data-pi-add-cart-sheet>' +
        (this._config.addToCartLabel || 'Add to cart') +
        '</button>';
      var self = this;
      this._wireProductUi(p, this._sheetScroll);
      this._wireProductUi(p, this._sheetFooter);
      var acc = this._sheetScroll.querySelector('[data-pi-acc-sheet]');
      if (acc) {
        acc.addEventListener('click', function () {
          acc.closest('.pi-advanced-ugc-modal__accordion').classList.toggle('is-open');
        });
      }
      requestAnimationFrame(function () {
        var g = self._sheetScroll.querySelector('.pi-advanced-ugc-modal__sheet-gallery.swiper');
        if (g && window.Swiper) {
          new window.Swiper(g, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            on: {
              slideChange: function (sw) {
                var bar = self._sheetScroll.querySelector('[data-pi-sheet-gallery-progress]');
                if (bar && sw.slides.length) bar.style.width = ((sw.activeIndex + 1) / sw.slides.length) * 100 + '%';
              }
            }
          });
        }
      });
    }

    _variantHtml(p) {
      if (!p.options || !p.options.length) return '';
      var html = '';
      for (var o = 0; o < p.options.length; o++) {
        var opt = p.options[o];
        html += '<div class="pi-advanced-ugc-modal__variant-label">' + escapeHtml(opt.name) + ' :</div><div class="pi-advanced-ugc-modal__variant-options" data-pi-opt-idx="' + o + '">';
        for (var j = 0; j < opt.values.length; j++) {
          var val = opt.values[j];
          var sel = this._selectedOptions[o] === val;
          html +=
            '<button type="button" class="pi-advanced-ugc-modal__variant-btn' +
            (sel ? ' is-selected' : '') +
            '" data-pi-opt="' +
            escapeAttr(val) +
            '">' +
            escapeHtml(val) +
            '</button>';
        }
        html += '</div>';
      }
      return html;
    }

    _wireProductUi(p, container) {
      var self = this;
      container.querySelectorAll('[data-pi-opt]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var wrap = btn.closest('[data-pi-opt-idx]');
          if (!wrap) return;
          var idx = parseInt(wrap.getAttribute('data-pi-opt-idx'), 10);
          var val = btn.getAttribute('data-pi-opt');
          self._selectedOptions[idx] = val;
          wrap.querySelectorAll('.pi-advanced-ugc-modal__variant-btn').forEach(function (b) {
            b.classList.toggle('is-selected', b.getAttribute('data-pi-opt') === val);
          });
          self._renderProductColumn(p);
          self._renderMobileStrip(p);
          if (self._sheet && self._sheet.open) self._renderSheet(p);
        });
      });
      var add = container.querySelector('[data-pi-add-cart], [data-pi-add-cart-sheet]');
      if (add) {
        add.addEventListener('click', function () {
          self._addToCart(p);
        });
      }
      var acc = container.querySelector('[data-pi-acc]');
      if (acc) {
        acc.addEventListener('click', function () {
          acc.closest('.pi-advanced-ugc-modal__accordion').classList.toggle('is-open');
        });
      }
    }

    _addToCart(p) {
      var v = findVariantForOptions(p, this._selectedOptions);
      if (!v || !v.id) return;
      var fd = new FormData();
      fd.append('id', String(v.id));
      fd.append('quantity', '1');
      var url = (window.Shopify && Shopify.routes && Shopify.routes.cart_add) || '/cart/add';
      fetch(url + '.js', {
        method: 'POST',
        body: fd,
        headers: { Accept: 'application/json' }
      })
        .then(function (r) {
          return r.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function () {});
    }
  }

  function escapeHtml(s) {
    if (!s) return '';
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function escapeAttr(s) {
    if (!s) return '';
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }

  class PiUgcSlider extends HTMLElement {
    connectedCallback() {
      if (this._piInited) return;
      var self = this;
      if (typeof window.Swiper === 'undefined') {
        this._piRetry = (this._piRetry || 0) + 1;
        if (this._piRetry < 60) {
          setTimeout(function () {
            if (self.isConnected) self.connectedCallback();
          }, 50);
        }
        return;
      }

      var config = parseJson(this, 'script[data-pi-adv-ugc-config]');
      if (!config) return;

      var swiperEl = this.querySelector('.pi-advanced-ugc-slider__swiper.swiper');
      if (!swiperEl) return;

      var rootSlider = this.querySelector('.pi-advanced-ugc-slider');
      var bp = parseInt(config.breakpoint, 10) || 990;
      var wrapper = swiperEl.querySelector('.swiper-wrapper');
      var originalSlideCount = wrapper ? wrapper.querySelectorAll('.swiper-slide').length : 0;
      var spvDesk = config.slidesPerViewDesktop != null ? config.slidesPerViewDesktop : 5;
      var spvDeskNum = typeof spvDesk === 'number' ? spvDesk : parseFloat(String(spvDesk)) || 5;
      /** Never ask for more columns than real slides (avoids huge empty side gaps). */
      var spvEff = Math.min(Math.max(1, Math.floor(spvDeskNum)), Math.max(1, originalSlideCount));
      var initialMob = parseInt(config.initialSlideMobile, 10);
      if (isNaN(initialMob)) initialMob = 1;
      initialMob = Math.min(Math.max(0, initialMob), Math.max(0, originalSlideCount - 1));
      var initialDesk = parseInt(config.initialSlideDesktop, 10);
      if (isNaN(initialDesk)) initialDesk = 2;
      initialDesk = Math.min(Math.max(0, initialDesk), Math.max(0, originalSlideCount - 1));
      /**
       * Swiper loop needs roughly slidesPerView * 2 real slides; otherwise it turns loop off and the track looks broken.
       * When loop is not possible, rewind gives smooth wrap end→start without duplicates.
       */
      var loopOkDesktop =
        !config.coverflow && originalSlideCount >= 3 && originalSlideCount >= spvEff * 2;
      var rewindDesktop = !config.coverflow && !loopOkDesktop && originalSlideCount >= 2;

      var stepScaleRaf = null;
      /**
       * Stepped sizes from Swiper slide progress (0 = viewport center) so the centered slide is always largest.
       * Applies on both mobile + desktop (unless coverflow is enabled).
       */
      function applyStepScales(sw) {
        if (!rootSlider || config.coverflow) {
          if (rootSlider) rootSlider.classList.remove('pi-advanced-ugc-slider--step-apply');
          return;
        }

        rootSlider.classList.add('pi-advanced-ugc-slider--step-apply');

        var slides = sw.slides;
        var progArr = sw.slidesProgress;
        var isDesktop = (window.innerWidth || 0) >= bp;
        var minScale = isDesktop ? 0.64 : 0.7;
        var falloff = isDesktop ? 0.28 : 0.24;

        for (var i = 0; i < slides.length; i++) {
          var slide = slides[i];
          var pr = 0;
          if (progArr && typeof progArr[i] === 'number' && !isNaN(progArr[i])) pr = progArr[i];
          else if (typeof slide.progress === 'number' && !isNaN(slide.progress)) pr = slide.progress;
          var ap = Math.abs(pr);
          var sc = Math.max(minScale, 1 - Math.min(ap, 1.35) * falloff);
          slide.style.setProperty('--pi-adv-step-scale', String(sc));
          slide.style.zIndex = String(8 + Math.round((1 - Math.min(ap, 1)) * 12));
        }
      }

      function scheduleStepScales(sw) {
        if (stepScaleRaf) return;
        stepScaleRaf = requestAnimationFrame(function () {
          stepScaleRaf = null;
          applyStepScales(sw);
        });
      }

      var opts = {
        speed: 480,
        roundLengths: true,
        initialSlide: initialMob,
        slidesPerView: config.slidesPerViewMobile != null ? config.slidesPerViewMobile : 'auto',
        spaceBetween: parseInt(config.spaceBetweenMobile, 10) || 12,
        centeredSlides: !!config.centeredSlidesMobile,
        watchSlidesProgress: true,
        watchOverflow: false,
        grabCursor: true,
        observer: true,
        observeParents: true,
        breakpoints: {}
      };
      opts.breakpoints[bp] = {
        initialSlide: initialDesk,
        slidesPerView: spvEff,
        spaceBetween: parseInt(config.spaceBetweenDesktop, 10) || 20,
        centeredSlides: config.centeredSlidesDesktop !== false,
        centerInsufficientSlides: true,
        slidesPerGroup: 1,
        loop: loopOkDesktop,
        loopAdditionalSlides: Math.min(originalSlideCount, Math.max(spvEff, 2)),
        rewind: rewindDesktop
      };

      if (config.coverflow) {
        opts.effect = 'coverflow';
        opts.coverflowEffect = {
          rotate: parseInt(config.coverflowRotate, 10) || 0,
          stretch: parseInt(config.coverflowStretch, 10) || 0,
          depth: parseInt(config.coverflowDepth, 10) || 80,
          modifier: config.coverflowModifier != null ? Number(config.coverflowModifier) : 1,
          slideShadows: false
        };
      }

      var prev = this.querySelector('.pi-advanced-ugc-slider__nav-btn--prev');
      var next = this.querySelector('.pi-advanced-ugc-slider__nav-btn--next');
      if (prev && next) {
        opts.navigation = { prevEl: prev, nextEl: next };
      }

      var autoplaySec = parseInt(config.videoAutoplaySeconds, 10);
      var timers = [];

      function clearTimers() {
        timers.forEach(function (t) {
          clearTimeout(t);
        });
        timers = [];
      }

      /** Query each time: loop mode duplicates slides and their <video> nodes (not in a stale NodeList). */
      function pauseVideosExcept(activeSlide) {
        swiperEl.querySelectorAll('.pi-advanced-ugc-slider__video[data-pi-slide-video]').forEach(function (v) {
          if (!activeSlide || !activeSlide.contains(v)) {
            try {
              v.pause();
            } catch (e) {}
            try {
              v.muted = true;
              v.removeAttribute('controls');
            } catch (e) {}
            var s = v.closest('.swiper-slide');
            if (s) s.classList.remove('pi-adv-user-playing');
          }
        });
      }

      function syncActiveSlide(sw) {
        sw.slides.forEach(function (s) {
          s.classList.toggle('is-active', s.classList.contains('swiper-slide-active'));
        });
      }

      function runPeekForIndex(sw) {
        if (!autoplaySec || autoplaySec <= 0) return;
        var slide = sw.el.querySelector('.swiper-slide-active');
        if (!slide) return;
        if (slide.classList.contains('pi-adv-user-playing')) return;
        var vid = slide.querySelector('.pi-advanced-ugc-slider__video[data-pi-slide-video]');
        if (!vid) return;
        clearTimers();
        pauseVideosExcept(slide);
        try {
          vid.currentTime = 0;
          vid.muted = true;
          vid.removeAttribute('controls');
          vid.play().catch(function () {});
        } catch (e) {}
        var t = setTimeout(function () {
          try {
            vid.pause();
          } catch (e) {}
        }, autoplaySec * 1000);
        timers.push(t);
      }

      function positionDesktopInitial(sw) {
        if (config.coverflow || !originalSlideCount) return;
        if ((window.innerWidth || 0) < bp) return;
        if (!sw || !sw.el || !sw.isConnected) return;
        try {
          if (loopOkDesktop && typeof sw.slideToLoop === 'function') {
            sw.slideToLoop(initialDesk, 0);
          } else if (typeof sw.slideTo === 'function') {
            sw.slideTo(initialDesk, 0);
          }
          if (typeof sw.update === 'function') sw.update();
        } catch (e) {}
        syncActiveSlide(sw);
        applyStepScales(sw);
        runPeekForIndex(sw);
      }

      function positionMobileInitial(sw) {
        if (!originalSlideCount) return;
        if ((window.innerWidth || 0) >= bp) return;
        if (!sw || !sw.el || !sw.isConnected) return;
        try {
          if (typeof sw.slideTo === 'function') sw.slideTo(initialMob, 0);
          if (typeof sw.update === 'function') sw.update();
        } catch (e) {}
        syncActiveSlide(sw);
        applyStepScales(sw);
        runPeekForIndex(sw);
      }

      var lastBpCross = (window.innerWidth || 0) >= bp;
      opts.on = {
        init: function (sw) {
          syncActiveSlide(sw);
          applyStepScales(sw);
          requestAnimationFrame(function () {
            if ((window.innerWidth || 0) >= bp) positionDesktopInitial(sw);
            else positionMobileInitial(sw);
          });
        },
        slideChange: function (sw) {
          syncActiveSlide(sw);
          applyStepScales(sw);
          // Leaving a user-playing slide should stop "full play" mode.
          pauseVideosExcept(sw.el.querySelector('.swiper-slide-active'));
        },
        slideChangeTransitionEnd: function (sw) {
          runPeekForIndex(sw);
          applyStepScales(sw);
        },
        progress: function (sw) {
          scheduleStepScales(sw);
        },
        setTranslate: function (sw) {
          scheduleStepScales(sw);
        },
        resize: function (sw) {
          applyStepScales(sw);
        },
        breakpoint: function (sw) {
          var nw = window.innerWidth || 0;
          syncActiveSlide(sw);
          applyStepScales(sw);
          if (!lastBpCross && nw >= bp) {
            requestAnimationFrame(function () {
              positionDesktopInitial(sw);
            });
          }
          if (lastBpCross && nw < bp) {
            requestAnimationFrame(function () {
              positionMobileInitial(sw);
            });
          }
          lastBpCross = nw >= bp;
        }
      };

      this._swiper = new window.Swiper(swiperEl, opts);

      var sw0 = this._swiper;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if ((window.innerWidth || 0) >= bp) positionDesktopInitial(sw0);
          else positionMobileInitial(sw0);
        });
      });

      var resizeT;
      this._onStepResize = function () {
        clearTimeout(resizeT);
        resizeT = setTimeout(function () {
          if (self._swiper) applyStepScales(self._swiper);
        }, 120);
      };
      window.addEventListener('resize', this._onStepResize);

      var sectionEl = self.closest('[id^="shopify-section-"]');
      var modal = sectionEl ? sectionEl.querySelector('pi-advanced-ugc-modal') : null;
      this._openModal = function (index) {
        if (modal && typeof modal.openMain === 'function') modal.openMain(index);
      };

      this.querySelectorAll('[data-pi-open-modal]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var idx = parseInt(btn.getAttribute('data-pi-open-modal'), 10);
          if (!isNaN(idx)) self._openModal(idx);
        });
      });

      /** Tap active slide (media area): play full video with sound; tap again to pause. Peek timers cleared so clip does not auto-stop. */
      this._swiperEl = swiperEl;
      this._onSlideMediaClick = function (e) {
        if (e.target.closest('button, a, [data-pi-open-modal], .pi-advanced-ugc-slider__nav, .pi-advanced-ugc-slider__product-pill, .pi-advanced-ugc-slider__active-bar')) {
          return;
        }
        var slide = e.target.closest('.swiper-slide');
        if (!slide || !slide.classList.contains('swiper-slide-active')) return;
        var vid = slide.querySelector('.pi-advanced-ugc-slider__video[data-pi-slide-video]');
        if (!vid) return;
        e.preventDefault();
        clearTimers();
        pauseVideosExcept(slide);
        try {
          if (!vid.paused && !vid.muted && !vid.ended) {
            vid.pause();
            slide.classList.remove('pi-adv-user-playing');
            vid.muted = true;
            vid.removeAttribute('controls');
            return;
          }
          slide.classList.add('pi-adv-user-playing');
          vid.muted = false;
          vid.setAttribute('controls', 'controls');
          vid.play().catch(function () {});

          if (!vid._piFullPlayBound) {
            vid._piFullPlayBound = true;
            vid.addEventListener('ended', function () {
              try {
                vid.muted = true;
                vid.removeAttribute('controls');
              } catch (e2) {}
              slide.classList.remove('pi-adv-user-playing');
            });
            vid.addEventListener('pause', function () {
              if (vid.ended) return;
              // If user pauses manually, bring icon back.
              slide.classList.remove('pi-adv-user-playing');
            });
          }
        } catch (err) {}
      };
      swiperEl.addEventListener('click', this._onSlideMediaClick);

      this._piInited = true;
    }

    disconnectedCallback() {
      if (this._swiperEl && this._onSlideMediaClick) {
        try {
          this._swiperEl.removeEventListener('click', this._onSlideMediaClick);
        } catch (e) {}
        this._onSlideMediaClick = null;
        this._swiperEl = null;
      }
      if (this._onStepResize) {
        window.removeEventListener('resize', this._onStepResize);
        this._onStepResize = null;
      }
      if (this._swiper && typeof this._swiper.destroy === 'function') {
        try {
          this._swiper.destroy(true, true);
        } catch (e) {}
        this._swiper = null;
      }
      this._piInited = false;
    }
  }

  if (!customElements.get('pi-advanced-ugc-modal')) {
    customElements.define('pi-advanced-ugc-modal', PiUgcModal);
  }
  if (!customElements.get('pi-advanced-ugc-slider')) {
    customElements.define('pi-advanced-ugc-slider', PiUgcSlider);
  }
})();
